import Roles from "~/utils/roles";

export default defineNuxtRouteMiddleware((to, from) => {
    const {currentRoutePath, isAuthenticated, user} = useAuth()
    const {isAuthorized} = usePermissions()
    currentRoutePath.value = to.path
})